/**
 * Golden Hour delivery estimate.
 *
 * Fills every [data-ghw-delivery] element with a real date range:
 * "Order today, arrives Sep 25 – Oct 5", counting only business days and
 * skipping weekends plus Canadian federal holidays (observed on the next
 * weekday when they fall on a weekend). Without JavaScript the Liquid
 * fallback "in 7–13 business days" stays visible.
 */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function key(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function observed(d) {
    var w = d.getDay();
    if (w === 6) d.setDate(d.getDate() + 2);
    else if (w === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function nthMonday(year, month, n) {
    var d = new Date(year, month, 1);
    var offset = (8 - d.getDay()) % 7;
    d.setDate(1 + offset + (n - 1) * 7);
    return d;
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  function holidays(year) {
    var list = [];
    var easter = easterSunday(year);
    var goodFriday = new Date(easter);
    goodFriday.setDate(easter.getDate() - 2);

    // Victoria Day: the Monday before May 25
    var victoria = new Date(year, 4, 24);
    while (victoria.getDay() !== 1) victoria.setDate(victoria.getDate() - 1);

    var christmas = observed(new Date(year, 11, 25));
    var boxing = observed(new Date(year, 11, 26));
    if (key(boxing) === key(christmas)) boxing.setDate(boxing.getDate() + 1);

    list.push(observed(new Date(year, 0, 1))); // New Year's Day
    list.push(goodFriday);
    list.push(victoria);
    list.push(observed(new Date(year, 6, 1))); // Canada Day
    list.push(nthMonday(year, 8, 1)); // Labour Day
    list.push(observed(new Date(year, 8, 30))); // National Day for Truth and Reconciliation
    list.push(nthMonday(year, 9, 2)); // Thanksgiving
    list.push(observed(new Date(year, 10, 11))); // Remembrance Day
    list.push(christmas);
    list.push(boxing);

    var set = {};
    for (var i = 0; i < list.length; i++) set[key(list[i])] = true;
    return set;
  }

  var cache = {};

  function isHoliday(d) {
    var y = d.getFullYear();
    if (!cache[y]) cache[y] = holidays(y);
    return !!cache[y][key(d)];
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6) continue;
      if (isHoliday(d)) continue;
      n--;
    }
    return d;
  }

  function run() {
    var els = document.querySelectorAll('[data-ghw-delivery]');
    if (!els.length) return;
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-CA', { month: 'short', day: 'numeric' });
    } catch (e) {
      return;
    }
    var now = new Date();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 13;
      var target = el.querySelector('[data-ghw-eta]');
      if (!target) continue;
      var a = addBusinessDays(now, min);
      var b = addBusinessDays(now, max);
      target.textContent = fmt.format(a) + ' – ' + fmt.format(b);
      el.setAttribute('data-ghw-delivery', 'ready');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-run when Horizon swaps markup: variant changes re-render sections, and
  // the cart drawer morphs its summary after every add or quantity change.
  document.addEventListener('shopify:section:load', run);
  // Shopify's standard cart event; 'cart:update' stays as a fallback.
  document.addEventListener('shopify:cart:lines-update', run);
  document.addEventListener('cart:update', run);
  var observer = null;
  if ('MutationObserver' in window) {
    observer = new MutationObserver(function () {
      if (document.querySelector('[data-ghw-delivery]:not([data-ghw-delivery="ready"])')) run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
